import {
  Text,
  Flex,
  Heading,
  Stack,
  StackItem,
  Image,
  Divider,
  Icon,
  Box,
  Link,
  ScaleFade,
  Wrap,
  WrapItem,
} from "@chakra-ui/react";
import { useMemo, useRef } from "react";
import rock from "../../assets/img/fut.png";
import profilePhoto from "../../assets/img/profile.png";
import questionImg from "../../assets/img/int-icon.png";

import { container, item } from "./animationConfig";

import { BsChevronDoubleDown, BsChevronDoubleUp } from "react-icons/bs";
import { SlideFade } from "@chakra-ui/react";
import { skills } from "./skills";
import { motion, AnimatePresence } from "framer-motion";

import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from "react-responsive-carousel";

import certf_1 from "../../assets/img/certificado_1.png";
import certf_2 from "../../assets/img/certificado_2.png";
import certf_3 from "../../assets/img/certificado_3.png";
import certf_4 from "../../assets/img/certificado_4.png";
import certf_5 from "../../assets/img/certificado_5.png";
import certf_6 from "../../assets/img/certificado_6.png";
import certf_7 from "../../assets/img/certificado_7.png";
import certf_8 from "../../assets/img/certificado_8.png";
import certf_9 from "../../assets/img/certificado_9.png";
import certf_10 from "../../assets/img/certificado_10.png";
import certf_11 from "../../assets/img/certificado_11.png";
import certf_12 from "../../assets/img/certificado_12.png";
import certf_13 from "../../assets/img/certificado_13.png";
import certf_14 from "../../assets/img/certificado_14.png";
import certf_15 from "../../assets/img/certificado_15.png";
import certf_16 from "../../assets/img/certificado_16.png";
import certf_17 from "../../assets/img/certificado_17.png";

import { useObserver } from "./observers";
import AnimatedStars from "../../components/AnimatedStars";
import Astro from "../../components/Astro";

const About = () => {
  const skillsRef = useRef(null);
  const aboutRef = useRef(null);
  const hobbiesRef = useRef(null);
  const presentationRef = useRef(null);

  const certifications = useMemo(() => {
    return [
      certf_1,
      certf_2,
      certf_3,
      certf_4,
      certf_5,
      certf_6,
      certf_7,
      certf_8,
      certf_9,
      certf_10,
      certf_11,
      certf_12,
      certf_13,
      certf_14,
      certf_15,
      certf_16,
      certf_17,
    ];
  }, []);

  const { inViewport: presentationViewPort } = useObserver(presentationRef);
  const { inViewport: aboutViewPort } = useObserver(aboutRef);
  const { inViewport: hobbiesViewPort } = useObserver(hobbiesRef);
  const { inViewport: skillsViewPort } = useObserver(skillsRef);

  const wrapperRef = useRef(null);

  const getExperienceTime = () => {
    const startDate = new Date("2022-01-01"); // coloque sua data de início real aqui
    const now = new Date();

    let years = now.getFullYear() - startDate.getFullYear();
    let months = now.getMonth() - startDate.getMonth();

    if (months < 0) {
      years--;
      months += 12;
    }

    return `${years} ano${years !== 1 ? 's' : ''} e ${months} mês${months !== 1 ? 'es' : ''}`;
  };

  const experienceTime = useMemo(() => getExperienceTime(), []);

  return (
    <AnimatePresence>
      <Box
        as={motion.div}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <Astro wrapper={wrapperRef} />

        <Flex
          gap={5}
          h="100vh"
          w="100%"
          align="center"
          overflowY="auto"
          py={24}
          overflowX="hidden"
          flexDirection="column"
          position="relative"
          scrollBehavior="smooth"
          ref={wrapperRef}
          css={{
            "&::-webkit-scrollbar": {
              width: "5px",
              height: "10px",
            },
            "&::-webkit-scrollbar-track": {
              width: "6px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "rgb(196, 196, 196)",
              borderRadius: "24px",
            },
          }}
        >
       <Stack
  id="top"
  direction={{ base: "column", md: "row" }}
  justify="space-between"
  alignItems="center"
  w="100%"
  maxW="700px"
  spacing={{ base: 6, md: 10 }}
>
  <StackItem
    as={SlideFade}
    in={presentationViewPort}
    offsetX="-50%"
    transition="all 1s"
  >
    <Image src={profilePhoto} w={300} ref={presentationRef} />
  </StackItem>

  <Divider
    orientation="vertical"
    bgColor="white"
    h="100px"
    display={{ base: "none", md: "block" }}
  />

  <StackItem
    maxW="350px"
    as={SlideFade}
    in={presentationViewPort}
    offsetY="-50%"
    transition="all 1s"
  >
    <Text
      fontSize={{ base: "2xl", md: "3xl" }}
      fontWeight="bold"
      textShadow="2px 2px #ff0050, -2px -2px #00f2ea"
      mb={2}
    >
      Sobre mim
    </Text>
    <Heading fontSize={{ base: "3xl", lg: "4xl" }} mb={1}>
      Lucas Esteves
    </Heading>
    <Text fontSize={{ base: "sm", md: "md" }} mb={1}>
      Desenvolvedor FullStack
    </Text>
    <Text fontSize={{ base: "sm", md: "md" }} lineHeight="1.6">
      Olá, meu nome é Lucas! Sou graduado em Tecnologia da Informação e atuo como desenvolvedor pleno especializado em .NET.
    </Text>
  </StackItem>
</Stack>

<Box as={motion.div} whileHover={{ scale: 1.5 }} whileTap={{ scale: 0.8, borderRadius: "100%" }}>
  <Link href="#about">
    <Icon as={BsChevronDoubleDown} fontSize={24} my={2} color="#00f2ea" />
  </Link>
</Box>

<Stack
  id="about"
  direction={{ base: "column-reverse", md: "row" }}
  justify="space-between"
  alignItems="center"
  w="100%"
  maxW="700px"
  spacing={{ base: 6, md: 10 }}
>
  <StackItem
    maxW="350px"
    as={ScaleFade}
    initialScale={0.6}
    in={aboutViewPort}
    transition="all 1s"
  >
    <Text
      fontSize={{ base: "xl", md: "2xl" }}
      fontWeight="bold"
      textShadow="1.5px 1.5px #ff0050, -1.5px -1.5px #00f2ea"
      mb={3}
    >
      Experiência
    </Text>

    <Text fontSize={{ base: "md", md: "lg" }} fontWeight="bold">
      T2M - Desenvolvedor Pleno
    </Text>
    <Text fontSize={{ base: "sm", md: "md" }} color="gray.500" mb={2}>
      {experienceTime}
    </Text>
    <Text fontSize={{ base: "sm", md: "md" }} mb={5} lineHeight="1.6">
      Atuo no desenvolvimento de aplicações com .NET Framework e .NET Core, seguindo boas práticas de arquitetura e engenharia de software. Trabalho com Azure Functions, modelagem de processos com Camunda BPMN, mensageria com RabbitMQ, desenvolvimento com Angular, testes automatizados (SpecFlow) e integração com SQL Server e Cosmos DB na Azure.
    </Text>
  </StackItem>

  <StackItem
    textAlign="center"
    as={SlideFade}
    in={aboutViewPort}
    offsetX="50%"
    transition="all 1s"
  >
    <Heading
      fontSize={{ base: "3xl", lg: "4xl" }}
      textShadow="2px 2px #ff0050, -2px -2px #00f2ea"
      mb={4}
    >
      O que faço?
    </Heading>
    <Image src={questionImg} w={280} ref={aboutRef} />
  </StackItem>
</Stack>

<Box as={motion.div} whileHover={{ scale: 1.5 }} whileTap={{ scale: 0.8, borderRadius: "100%" }}>
  <Link href="#hobbies">
    <Icon as={BsChevronDoubleDown} fontSize={24} my={2} color="#00f2ea" />
  </Link>
</Box>

<Stack
  id="hobbies"
  direction={{ base: "column", md: "row" }}
  justify="space-between"
  alignItems="center"
  w="100%"
  maxW="700px"
  spacing={{ base: 6, md: 10 }}
>
  <StackItem
    textAlign="center"
    as={SlideFade}
    in={hobbiesViewPort}
    offsetX="-50%"
    transition="all 1s"
  >
    <Heading
      fontSize={{ base: "3xl", lg: "4xl" }}
      textShadow="2px 2px #ff0050, -2px -2px #00f2ea"
      mb={4}
    >
      Graduação 🎓
    </Heading>
    <Image src={rock} w={350} ref={hobbiesRef} />
  </StackItem>

  <StackItem
    maxW="350px"
    as={SlideFade}
    in={hobbiesViewPort}
    offsetX="50%"
    transition="all 1s"
  >
    <Text
      fontSize={{ base: "xl", md: "2xl" }}
      fontWeight="bold"
      textShadow="2px 2px #ff0050, -2px -2px #00f2ea"
      mb={3}
    >
      Formação
    </Text>

    <Text fontSize={{ base: "md", md: "lg" }} fontWeight="bold">
      Faeterj - Curso Superior de Tecnologia (CST)
    </Text>
    <Text fontSize={{ base: "sm", md: "md" }} color="gray.500" mb={2}>
      2022 – 2025
    </Text>
    <Text fontSize={{ base: "sm", md: "md" }} mb={5} lineHeight="1.6">
      Durante a graduação, desenvolvi uma base sólida em desenvolvimento de software, arquitetura de sistemas e bancos de dados. Essa formação foi essencial para atuar com eficiência em ambientes modernos, aplicando boas práticas e foco em escalabilidade.
    </Text>
  </StackItem>
</Stack>

        
        
        
        
          <Box
            as={motion.div}
            whileHover={{ scale: 1.5 }}
            whileTap={{
              scale: 0.8,
              borderRadius: "100%",
            }}
          >
            <Link href="#skills">
              <Icon
                as={BsChevronDoubleDown}
                fontSize={24}
                my={1}
                color="#00f2ea"
              />
            </Link>
          </Box>

{/* SKILS */}
     <Stack
  id="skills"
  spacing={10}
  justify="center"
  alignItems="center"
  w="100%"
  maxW="700px"
>
  <StackItem>
    <Heading
      fontSize={{ base: "3xl", lg: "4xl" }}
      textShadow="2px 2px #ff0050, -2px -2px #00f2ea"
      textAlign="center"
    >
      Skills
    </Heading>
  </StackItem>

  <StackItem w="100%">
    <Wrap
      ref={skillsRef}
      spacing={{ base: 4, md: 6 }}
      justify="center"
      as={motion.ul}
      variants={container}
      initial="hidden"
      animate={skillsViewPort ? "visible" : ""}
      maxW="700px"
    >
      {skills.map(({ label, icon }, i) => (
        <WrapItem
          key={i}
          display="flex"
          flexDirection="column"
          alignItems="center"
          as={motion.li}
          variants={item}
          p={3}
          rounded="md"
          whileHover={{
            color: "#00f2ea",
            scale: 1.2,
            textShadow: "1.5px 1.5px #ff0050, -1.5px -1.5px #00f2ea",
          }}
          whileTap={{
            color: "#00f2ea",
            scale: 1.2,
            textShadow: "1.5px 1.5px #ff0050, -1.5px -1.5px #00f2ea",
          }}
        >
          <Icon
            as={icon}
            fontSize={{ base: 36, md: 32 }}
            rounded="full"
          />
          <Text
            display={{ base: "none", md: "block" }}
            fontSize="sm"
            mt={2}
          >
            {label}
          </Text>
        </WrapItem>
      ))}
    </Wrap>
  </StackItem>
</Stack>



{/* CURSOS */}

<Box
  as={motion.div}
  whileHover={{ scale: 1.5 }}
  whileTap={{
    scale: 0.8,
    borderRadius: "100%",
  }}
  mt={10}
>
  <Link href="#qualifications">
    <Icon
      as={BsChevronDoubleDown}
      fontSize={24}
      my={2}
      color="#00f2ea"
    />
  </Link>
</Box>

<Stack
  id="qualifications"
  justify="center"
  alignItems="center"
  w="100%"
  maxW="700px"
  spacing={10}
>
  <StackItem>
    <Heading
      fontSize={{ base: "3xl", lg: "4xl" }}
      textShadow="2px 2px #ff0050, -2px -2px #00f2ea"
      textAlign="center"
    >
      Qualificações
    </Heading>
  </StackItem>

  <StackItem maxW="700px" w="100%" zIndex="999">
    <Carousel autoPlay infiniteLoop>
      {certifications.map((certfImg, i) => (
        <div key={i}>
          <img src={certfImg} alt={`certification-${i}`} />
        </div>
      ))}
    </Carousel>
  </StackItem>
</Stack>





          <Box
            as={motion.div}
            whileHover={{ scale: 1.5 }}
            whileTap={{
              scale: 0.8,
              borderRadius: "100%",
            }}
          >
            <Link href="#top">
              <Icon
                as={BsChevronDoubleUp}
                fontSize={24}
                my={1}
                color="#00f2ea"
              />
            </Link>
          </Box>
          <AnimatedStars />
        </Flex>
      </Box>
    </AnimatePresence>
  );
};

export default About;
